import React from 'react';
import SchedulingManagement from './SchedulingManagement';

export default function GESchedulingManagement(props) {
  return <SchedulingManagement {...props} isGeneralEducation />;
}
